import React from 'react'

import { Box, Heading2 } from '@gousto-internal/citrus-react'
import type { SimpleTitleContentBlock } from '@library/api-menu-experience'

type SimpleTitleProps = {
  contentBlock: SimpleTitleContentBlock
}

export const SimpleTitle = ({ contentBlock }: SimpleTitleProps) => (
  <Box paddingBottom={2} paddingH={[3, 3, 0]}>
    <Heading2>{contentBlock.title}</Heading2>
  </Box>
)
